<template>
  <v-card align="center" justify="center" min-width="20vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_ChangeToken') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-icon class="mb-7" color="primary" size="70">fa-sync-alt</v-icon>
      <p v-html="$t('message_ChangeToken')"/>
      <v-btn class="mt-2" @click="changeToken">{{ $t('btnChange') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/auth';
import { mapMutations } from 'vuex';
export default {
  name: "ChangeToken",
  methods: {
    ...mapMutations(['setAutomationToken']),
    changeToken() {
      Repository.changeAutomationToken().then((response) => {
        if(response.status < 400 && response.data !== null) {
          alert(`Automation token was successfully changed!\nThe new automation token is: ${response.data}`);
          this.setAutomationToken(response.data);
          this.close();
        }
        else
          alert('An error occurred.');
      });
    },
    close() {
      this.$emit('closeWindow');
    }
  }
}
</script>



<style scoped>

</style>
